import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito saber usar computadoras?',
    answer: 'Para nada. Todo el método está diseñado para funcionar desde tu celular. Si sabes mandar un mensaje de WhatsApp, sabes todo lo que necesitas para empezar.'
  }, {
    question: 'Ya intenté vender antes y no funcionó, ¿por qué esto es diferente?',
    answer: "Porque los otros métodos te enseñan a vender como empresa grande. Aquí aprenderás a vender como 'amiga', usando la confianza y las redes que ya tienes. Es más natural, sin presión y mucho más efectivo para nosotras."
  }, {
    question: '¿Qué pasa si no vendo nada?',
    answer: 'Tienes 30 días de garantía completa. Si sigues los pasos y no ves resultados, te devolvemos cada centavo sin preguntas. El riesgo es cero.'
  }, {
    question: '¿Necesito hablar inglés?',
    answer: 'No. Toda la guía está en español y las comunidades de compradores que te enseñamos son mayormente latinas. Tu idioma es tu ventaja.'
  }, {
    question: '¿Cuánto tiempo necesito dedicarle?',
    answer: 'Con 1-2 horas al día es suficiente para empezar. Muchas de nuestras alumnas lo hacen mientras cuidan a sus nietos o en las tardes después de cenar.'
  }, {
    question: '¿Cómo recibo la guía después de pagar?',
    answer: 'Inmediatamente. En menos de 5 minutos recibes un enlace en tu correo o directamente por WhatsApp. Sin esperas, sin complicaciones.'
  }];
  return <section className="py-20 bg-cream" data-id="element-1">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brown mb-4" data-id="element-4">
            Tus preguntas, respondidas con honestidad
          </h2>
        </div>

        <div className="space-y-4" data-id="element-5">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-6" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="bg-white rounded-xl shadow-sm border border-gold/10 overflow-hidden" data-id="element-7">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-8">
        <span className="text-lg font-serif font-bold text-brown pr-8" data-id="element-9">
          {question}
        </span>
        <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-gold text-white' : 'bg-cream text-gold'}`} data-id="element-10">
          {isOpen ? <Minus className="w-5 h-5" data-id="element-11" /> : <Plus className="w-5 h-5" data-id="element-12" />}
        </span>
      </button>

      <AnimatePresence data-id="element-13">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-14">
            <div className="px-6 pb-6 text-brown-light font-sans leading-relaxed border-t border-cream pt-4" data-id="element-15">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}